import { useEffect } from 'react';
import { APP_NAME } from '../constants';

const DEFAULT_DESCRIPTION =
  'Vediluxe - Discover elegant jewellery, earrings, necklaces, rings, bracelets and more. Handcrafted pieces for every occasion.';

const useDocumentTitle = (title?: string, description?: string) => {
  useEffect(() => {
    document.title = title
      ? `${title} | ${APP_NAME}`
      : `${APP_NAME} - Elegance, Every Day`;

    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute('content', description || DEFAULT_DESCRIPTION);
    }
  }, [title, description]);
};

export default useDocumentTitle;
